export default {
	termsAndConditions: {
		lastUpdate: 'آخر تحديث: 10 يونيو 2024',
		content: `
		<p>الشروط التي ستجدها أدناه مهمة للأسباب التالية:</p>
		<ul>
			<li>تؤسس حقوقك القانونية في {siteName}.</li>
			<li>توضح الحقوق التي تمنحها لنا عند استخدام {siteName}.</li>
			<li>
				تصف القواعد التي يجب على الجميع احترامها عند استخدام {siteName}.
			</li>
		</ul>
		<p>
			يرجى قراءة هذه الشروط بعناية، بالإضافة إلى {privacyPolicyLink} وأي
			مستندات أخرى مذكورة في هذه الشروط.
		</p>
		<p>دعنا نبدأ...</p>
		<h3>1. مقدمة وبيانات {siteNameUpper}.</h3>
		<p>
			الموقع الإلكتروني {websiteLink} (المشار إليه فيما يلي باسم "الموقع") مملوك لشركة
			{siteName} S.L (المشار إليها فيما يلي باسم "{siteName}")، وهي شركة
			تأسست وفقاً للتشريعات الإسبانية وعنوانها Avenida de
			Cerdanyola، رقم 75، الطابق الأول، سانت كوغات ديل فاييس (برشلونة)، حاملة رقم CIF
			B-56.768.260 ومسجلة في السجل التجاري لبرشلونة في المجلد
			49065، صفحة 0033، ورقة B-606324، التسجيل الأول.
		</p>
		<p>
			يضع {siteName} الموقع تحت تصرفك حتى تتمكن من التعرف علينا بشكل أفضل،
			ومعرفة الخدمات التي نقدمها وإذا رغبت في ذلك، يمكنك الاتصال
			والتعاقد معنا حسب الاقتضاء.
		</p>
		<h3>2. الغرض ونطاق تطبيق شروط الاستخدام</h3>
		<p>
			تشكل شروط الاستخدام هذه، جنباً إلى جنب مع {privacyPolicyLink} و
			{cookiesPolicyLink}، الإطار القانوني الذي ينظم استخدام الموقع
			{websiteLink}. ستكون شروط الاستخدام هذه متاحة لك على الموقع
			باللغة الإنجليزية حتى تتمكن من استشارتها أو حفظها أو طباعتها في أي وقت
			وكلما أردت ذلك.
		</p>
		<p>
			لمعرفة أي سؤال يتعلق بالمعالجة التي يقوم بها {siteName}
			لبياناتك الشخصية، يرجى زيارة {privacyPolicyLink} و {cookiesPolicyLink}.
			ستكون كلتا السياستين متاحتين لك باللغة الإنجليزية حتى تتمكن من
			استشارتهما أو حفظهما أو طباعتهما في أي وقت.<br />
			يستخدم {siteName} ملفات تعريف الارتباط الخاصة بأطراف ثالثة على الموقع. لمعرفة المزيد
			عن نوع ملفات تعريف الارتباط المستخدمة على الموقع {websiteLink}، والغرض منها وكيفية
			تكوين متصفحك في حالة عدم رغبتك في استخدامنا لملفات تعريف الارتباط هذه،
			يرجى زيارة {cookiesPolicyLink}.
		</p>
		<p>
			تم إعداد كل من شروط الاستخدام هذه و{privacyPolicyLink} و
			{cookiesPolicyLink} وفقاً لأحكام التشريعات السارية المعمول بها، من بينها
			القانون 34/2002 بشأن خدمات مجتمع المعلومات والتجارة الإلكترونية واللائحة (الاتحاد الأوروبي)
			2016/679 للبرلمان الأوروبي والمجلس، المؤرخة 27 أبريل 2016، فيما يتعلق
			بحماية الأشخاص الطبيعيين فيما يتعلق بمعالجة البيانات الشخصية والتداول
			الحر لهذه البيانات والتي تلغي التوجيه 95/46/CE.
		</p>
		<h3>3. الوصول إلى الموقع والقبول</h3>
		<p>
			الوصول إلى الموقع مجاني باستثناء الجزء المتعلق بتكلفة الاتصال
			من خلال شبكة الاتصالات التي يوفرها مزود خدمة الإنترنت
			الذي تعاقدت معه. يمكنك تصفح الموقع بحرية والوصول إليه
			كلما أردت. للوصول إلى الموقع وتصفحه، لست بحاجة إلى التسجيل،
			إلا إذا كنت ترغب في التعاقد على خدمة.
		</p>
		<p>
			استخدام الموقع يمنحك صفة مستخدم الموقع (المشار إليه فيما يلي باسم "المستخدم")
			ويعني قبولك الكامل وغير المشروط لشروط الاستخدام هذه، وكذلك {privacyPolicyLink}
			و{cookiesPolicyLink} للموقع. علاوة على ذلك، أنت توافق على عدم استخدام
			الخدمة لأغراض غير قانونية.
		</p>
		<p>
			من خلال الوصول إلى الموقع وتصفحه، فإنك تقر تحت مسؤوليتك الخاصة
			بأنك بالغ السن القانوني ولديك الأهلية القانونية اللازمة للوصول إلى الموقع
			واستخدامه، كما تقر بأنك تفهم وتقبل بشكل كامل شروط الاستخدام هذه
			دون تحفظ.
		</p>
		<p>
			من ناحية أخرى، نعلمك أنه لأسباب قانونية نقوم بأرشفة المستندات
			الإلكترونية التي يتم من خلالها إضفاء الطابع الرسمي على المشتريات. يمكنك الوصول
			إلى هذه المستندات في أي وقت عن طريق طلبها على: {supportLink}.
		</p>
		<h3>4. شروط استخدام الموقع</h3>
		<p>
			يوافق المستخدم على استخدام الموقع وفقاً لشروط الاستخدام هذه،
			والتشريعات السارية وحسن النية. وبالتالي، يكون المستخدم مسؤولاً أمام {siteName}
			وأمام أي طرف ثالث عن الأضرار والخسائر الناتجة عن
			الاستخدام المخالف لهذه الشروط والتشريعات وحسن النية من قبل
			المستخدم للموقع.
		</p>
		<h3>5. وصف الخدمة</h3>
		<p>
			من خلال الخدمة، يتيح {siteName} الاشتراك في الخدمة
			لتنفيذ تحرير الصور.
		</p>
		<p>
			ستكون اللغة التي سيتم بها إبرام العقد بين {siteName} والمشتري
			هي لغة بلد المنشأ.<br />
			ستكون عملية الشراء في الخدمة عبر الإنترنت كما يلي:
		</p>
		<ol>
			<li>يجب عليك التسجيل في الموقع باسم مستخدم وكلمة مرور.</li>
			<li>
				في وقت التسجيل، يجب على المستخدم اختيار إحدى خطط الدفع
				الموجودة في قسم الأسعار وسيتم منحه رصيداً حسب الخطة
				المختارة. سيسمح كل رصيد بتحرير صورة واحدة.
			</li>
			<li>
				بعد شراء الخدمة، سيكون لدى المستخدم لوحة إدارة
				حيث سيجد:
				<ul>
					<li>
						قسماً يحتوي على قائمة بجميع الصور التي تمت معالجتها، مع إمكانية
						تحريرها كما تريد وتنزيلها على جهازك.
					</li>
					<li>
						قسم الخطط والمدفوعات للاطلاع على الفواتير وإلغاء
						الاشتراك.
					</li>
					<li>قسم حسابي لتغيير تفضيلات الحساب.</li>
				</ul>
			</li>
		</ol>
		<p>
			بمجرد إتمام شراء الخدمة، سيتم تأكيدها عن طريق إرسال بريد إلكتروني،
			خلال مدة أقصاها 24 ساعة، إلى العنوان الذي قمت بتحديده. سيشير إلى
			الخدمة، وكيفية إلغاء الاشتراك، ومبلغها، والضرائب المطبقة، وطريقة الدفع
			والشروط والأحكام المطبقة.
		</p>
		<h4>5.1 الاشتراك</h4>
		<p>
			يختلف اشتراك الخدمة حسب الخطة المختارة وسيتم تجديده
			تلقائياً لنفس الفترة الزمنية حتى إنهائه. ما لم تقم بإلغاء اشتراكك،
			فإنك تفوضنا بتحميل رسوم الاشتراك السنوي المقابلة في طريقة الدفع الخاصة بك.
		</p>
		<p>
			يمكنك إلغاء اشتراكك في الخدمة في أي وقت، وستستمر في الوصول
			إليها حتى نهاية فترة الفوترة السنوية. إلى الحد الذي يسمح به القانون،
			المدفوعات غير قابلة للاسترداد ولا نقدم استردادات أو ائتمانات
			لفترات الاشتراك السنوية الجزئية.
		</p>
		<h3>6. السعر والضرائب</h3>
		<p>
			أسعار المنتجات المعروضة على {siteName} محددة باليورو
			(€) أو عملة البلد الذي يتم منه الشراء، ويتم فرض ضريبة
			القيمة المضافة (VAT) السارية وقت الشراء على سعر المنتجات.
		</p>
		<p>
			في أي حال، قد تكون العملية معفاة أو غير خاضعة لضريبة القيمة المضافة
			حسب بلد إقامتك أو الحالة التي تتصرف بها. لهذا السبب،
			في بعض الحالات قد يتغير السعر النهائي للطلب عن
			السعر المعروض.<br />
			المشتريات التي يقوم بها الأشخاص المعفيون من دفع ضريبة القيمة المضافة
			سيشيرون إلى ذلك عن طريق إرسال رقم VAT/NIF الخاص بهم عبر البريد الإلكتروني
			إلى {supportLink}، ولن يتم تسجيل المشتريات بهذه الضريبة.
		</p>
		<h3>7. طريقة الدفع</h3>
		<p>
			يمكن إجراء الدفع عبر الإنترنت للخدمة المشتراة عن طريق بطاقة الائتمان
			أو الخصم. في هذا الصدد، يُعلم {siteName} حاملي بطاقات الائتمان
			والخصم أن المعاملات في المتجر عبر الإنترنت تتم من خلال بوابة
			دفع آمنة، باستخدام تقنية SSL لضمان أمن نقل البيانات.
		</p>
		<h3>8. حق الانسحاب والاسترداد</h3>
		<h4>8.1. حق الانسحاب</h4>
		<p>
			نظراً لنوع المنتج المسوق في خدمتنا عبر الإنترنت، البرمجيات في
			شكل رقمي من QR، لن يكون حق الانسحاب قابلاً للتطبيق وفقاً
			للمادة 103، الحرف م) من المرسوم التشريعي الملكي 1/2007، المؤرخ 16 نوفمبر،
			الذي يعتمد النص المنقح للقانون العام لحماية المستهلكين
			والمستخدمين والقوانين التكميلية الأخرى.
		</p>
		<h4>8.2. الاسترداد</h4>
		<p>
			بغض النظر عن الخطة التي يختارها المستخدم، المبالغ التي يدفعها المستخدم
			وإلى الحد الذي يسمح به القانون لن تكون قابلة للاسترداد.
		</p>
		<p>
			لا يمكن التنازل عن الخدمة المتعاقد عليها أو نقلها إلى مستخدمين
			آخرين للخدمة.
		</p>
		<p>
			في أي حال، يمكن للمستخدم استخدام الخدمة المتعاقد عليها حتى نهاية
			الفترة المتعاقد عليها.
		</p>
		<h3>9. صلاحية العروض</h3>
		<p>
			الخدمات المعروضة في الخدمة، وأسعارها، ستكون متاحة للشراء
			طالما أنها في كتالوج الخدمات المعروض من خلال هذا
			الموقع.
		</p>
		<p>
			في أي حال، يحتفظ {siteName} بالحق في إجراء التعديلات التي
			يراها مناسبة في الخدمة، مع إمكانية تحديث المنتجات والخدمات
			حسب السوق.
		</p>
		<p>
			يحتفظ {siteName} بالحق في تغيير الأسعار دون إشعار مسبق. نعلمك
			أنه على الرغم من التحديثات التي تتم على أسعار الخدمة، قد تحتوي
			على أخطاء. سنصحح فوراً أي أخطاء تظهر، ولكنها لن تكون
			ملزمة للخدمة.
		</p>
		<h3>10. الأمان</h3>
		<p>
			كما هو مشار إليه أعلاه، تتم إجراءات الشراء بأكملها، وكذلك نقل
			بياناتك الشخصية وأنظمة الدفع، على صفحة آمنة وبطريقة مشفرة
			من خلال بروتوكول SSL.
		</p>
		<p>
			نضمن أمان الخدمة وفقاً للمعرفة التكنولوجية الحالية. ومع ذلك،
			لا يمكن لـ {siteName} ضمان الأمان المستقبلي الكامل للخدمة.
			في أي حال، نعد بتصحيح وتنفيذ الإجراءات التصحيحية المناسبة
			لتصحيح أي ثغرة أمنية محتملة في أقرب وقت ممكن.
		</p>
		<p>
			توافق على إخطار {siteName}، فوراً وعبر البريد الإلكتروني {supportLink}
			عن أي موقف قد يؤدي إلى انتحال هوية المستخدم.
		</p>
		<h3>11. التعديلات والبطلان</h3>
		<p>
			يمكننا تحديث شروط وأحكام الخدمة في المستقبل، وكذلك
			ميزات ووظائف الخدمة نفسها.
		</p>
		<p>
			سنعلمك بالتغييرات في الشروط والأحكام عن طريق وضع إشعار
			في مكان بارز على موقعنا و/أو عبر البريد الإلكتروني.
		</p>
		<p>
			إذا تم إعلان أي بند مدرج في هذه الشروط والأحكام، كلياً
			أو جزئياً، باطلاً أو غير فعال، فسيؤثر ذلك فقط على ذلك الحكم
			أو الجزء منه الذي يكون باطلاً أو غير فعال. ستبقى الشروط والأحكام
			في كل شيء آخر، مع اعتبار هذا الحكم، أو الجزء منه المتأثر،
			غير موجود.
		</p>
		<h3>12. المطالبات والإجراءات المستمدة من العقد</h3>
		<p>
			قدر الإمكان، تخضع هذه الخدمة للقانون الإسباني.<br />
			من أجل تبسيط حل المطالبات من خلال الإجراءات المدنية وتقليل
			التكاليف، لا نستبعد إمكانية الخضوع للتحكيم العادل لمحكمة
			التحكيم التابعة لغرف التجارة والصناعة. في هذا الصدد، ووفقاً
			للوائح المعمول بها، يُعلم {siteName} بوجود منصة أوروبية
			لحل النزاعات عبر الإنترنت تسهل الحل خارج المحكمة لمثل
			هذه النزاعات للعقود المبرمة أيضاً عبر الإنترنت بين المستهلكين
			ومقدمي خدمات الإنترنت. يمكن الوصول إلى هذه المنصة من خلال
			الموقع التالي:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. حقوق الملكية الفكرية والصناعية</h3>
		<p>
			يخضع الموقع ومحتوياته للحماية في تطبيق التشريعات الوطنية
			السارية بشأن الملكية الفكرية و/أو الصناعية، وكذلك في تطبيق
			الاتفاقيات الدولية المطبقة في مثل هذه المسائل. {siteName}
			هو المالك أو لديه ترخيص مناسب لجميع حقوق الملكية الفكرية
			والصناعية على الموقع ومحتوياته.
		</p>
		<p>
			يُحظر صراحةً أي شكل من أشكال النسخ أو التوزيع أو الاتصال العام
			أو التحويل أو الإتاحة وبشكل عام أي عمل استغلالي آخر سواء
			كان لأغراض تجارية أم لا للموقع أو محتوياته، دون الموافقة
			المسبقة الصريحة من {siteName}. يُحظر صراحةً محو البيانات
			التعريفية لـ {siteName} كمالك لحقوق الملكية الفكرية
			والصناعية للموقع أو محتوياته.
		</p>
		<p>
			يحتفظ {siteName} بجميع حقوق الملكية الفكرية والصناعية
			على الموقع ومحتوياته، كما يحتفظ بممارسة أي إجراءات
			قانونية تتوافق معه من أجل وقف أو منع أو ملاحقة أي
			استخدام غير مشروع للموقع أو محتوياته. في أي حال وتحت
			أي ظرف من الظروف لا يشكل الوصول إلى الموقع أو استخدامه
			من قبل المستخدم أو الأطراف الثالثة أو يعني تنازلاً من أي
			نوع من قبل {siteName} عن حقوق الملكية الفكرية أو
			الصناعية للموقع أو محتوياته. في أي حال لا يمكن فهم
			عدم مطالبة {siteName} بوقف استخدام الموقع أو
			محتواه غير القانوني أو المخالف لهذه الشروط على أنه
			موافقة ضمنية من {siteName} على مثل هذه الاستخدامات
			أو كتنازل عن ممارسة أي إجراء قانوني قد يتوافق معه.
		</p>
		<h3>14. المسؤوليات والضمانات</h3>
		<p>
			يجب على المستخدم استخدام الموقع ومحتوياته وفقاً لأحكام
			شروط الاستخدام هذه والتشريعات السارية وحسن النية. يُحظر
			صراحةً أي استخدام للموقع أو محتوياته مخالف لهذه الشروط
			العامة أو القانون أو حسن النية، بغض النظر عما إذا كان
			لهذا الاستخدام غرض اقتصادي أم لا.<br />
			سيكون المستخدم مسؤولاً عن أي ضرر أو أذى يلحق بـ {siteName}
			أو بالأطراف الثالثة ناتج بشكل مباشر أو غير مباشر عن أي
			استخدام يقوم به المستخدم للموقع أو محتوياته مخالف لهذه
			الشروط أو القانون أو الأخلاق أو النظام العام أو حسن النية.
		</p>
		<p>
			لكي يكون الموقع ومحتوياته متاحة للمستخدم، يتطلب {siteName}
			خدمات يقدمها أطراف ثالثة. من الممكن أنه على الرغم من
			الجهود التي يبذلها {siteName} للحفاظ على الموقع متاحاً
			ويمكن الوصول إليه للمستخدمين، قد يتم تعليق توفره أو
			مقاطعته أو إلغاؤه لأسباب خارجة عن سيطرة {siteName}.
			لهذا السبب لا يضمن {siteName} عدم وجود انقطاعات
			أو أخطاء في الوصول إلى الموقع أو محتوياته، ولا أنها
			محدثة أو معروضة دائماً في أحدث إصداراتها. وبالتالي،
			يرفض {siteName} أي مسؤولية عن الأضرار التي قد
			تلحق بالمستخدم أو الأطراف الثالثة نتيجة لتعليق أو
			انقطاع أو عدم استمرارية أو انقطاع الشبكة أو فصل
			الموقع.
		</p>
		<p>
			في أي حال وتحت أي ظرف من الظروف لن يكون {siteName}
			مسؤولاً عن الأضرار أو الخسائر التي تلحق بالمستخدم
			من أسباب غير منسوبة إلى {siteName} مثل، على سبيل
			المثال وليس الحصر، الكوارث الطبيعية أو حالات القوة
			القاهرة أو الطوارئ القصوى أو الفيروسات أو المكونات
			الضارة أو عطل المتصفح أو انقطاعات الشبكة أو
			التسللات الحاسوبية أو هجمات الأطراف الثالثة.
		</p>
		<h3>15. الروابط</h3>
		<p>
			يجب على المواقع الإلكترونية والمنصات والمنتديات والدردشات والمدونات أو شبكات التواصل الاجتماعي الخارجية التي ترتبط أو تحيل إلى الموقع الإلكتروني أن تُعلم بوضوح أنها لا تملك تصريحاً أو إشرافاً من {siteName} وأن هذا الارتباط أو الإحالة لا تعني أو تفترض أو تتضمن أي نوع من الشراكة بين {siteName} والمواقع الإلكترونية والمنصات والمنتديات والدردشات والمدونات أو شبكات التواصل الاجتماعي الخارجية التي ترتبط أو تحيل إلى الموقع الإلكتروني.
		</p>
		<p>
			في جميع الحالات، يجب أن يكون أي رابط موجه إلى الموقع الإلكتروني موجهاً مباشرة إلى الصفحة الرئيسية للموقع الإلكتروني من خلال النقر على عنوان URL للموقع الإلكتروني الذي يغطي الشاشة بأكملها للصفحة الرئيسية للموقع الإلكتروني، بحيث يكون الرابط مطلقاً وكاملاً دون استخدام الإطارات أو الروابط التشعبية. لا يتحمل {siteName} في أي حال من الأحوال وتحت أي ظرف من الظروف المسؤولية عن المحتوى أو المعلومات أو البيانات المتعلقة بالموقع الإلكتروني أو محتواه أو أي مسألة أخرى واردة في المواقع الإلكترونية أو المنصات أو المنتديات أو الدردشات أو المدونات أو الشبكات الاجتماعية التابعة لأطراف ثالثة التي ترتبط أو تحيل إلى الموقع الإلكتروني.
		</p>
		<p>
			يُمنع منعاً باتاً الربط أو الإحالة إلى الموقع الإلكتروني من المواقع الإلكترونية أو المنصات أو المنتديات أو الدردشات أو المدونات أو الشبكات الاجتماعية المخالفة للقانون والأخلاق والعادات الحسنة، وخاصة تلك التي تحتوي على محتوى إباحي أو غير مشروع أو غير قانوني أو ينتهك حقوق الإنسان.
		</p>
		<p>
			من ناحية أخرى، قد يحتوي الموقع الإلكتروني على روابط لمواقع إلكترونية ومنصات ومنتديات ودردشات ومدونات أو شبكات اجتماعية تابعة لأطراف ثالثة. لا يمتلك {siteName} الوسائل البشرية و/أو التقنية لمعرفة أو التحكم في المعلومات والمحتوى الذي يظهر على مواقع الأطراف الثالثة. لذلك، لن يكون {siteName} مسؤولاً بأي حال من الأحوال عن محتوى المواقع المرتبطة ولا يمكن اعتبار هذه الروابط تحت أي ظرف من الظروف معرفة فعالة بمحتوى المواقع التي تربط إليها.
		</p>
		<h3>16. حماية البيانات</h3>
		<p>
			كما هو منصوص عليه في {privacyPolicyLink}، يتعهد {siteName} باستخدام بيانات المستخدم، واحترام سريتها واستخدامها وفقاً للغرض من المعالجة، وكذلك الامتثال لالتزامه بحفظها واتخاذ جميع التدابير لتجنب التغيير أو الفقدان أو المعالجة أو الوصول غير المصرح به وفقاً لأحكام التشريعات الحالية المتعلقة بحماية البيانات الشخصية.
		</p>
		<p>
			يتضمن الموقع الإلكتروني ضمانات مناسبة ويستخدم تقنية قياسية في الصناعة لتحسين أمن وسلامة واكتمال ودقة وحماية البيانات الشخصية التي تم جمعها، وقد وضع احتياطات معقولة لحماية تلك المعلومات من الفقدان المحتمل أو سوء الاستخدام. تتم مراجعة قواعد حماية البيانات والأمن بشكل دوري وتحسينها عند الضرورة، ويسعى جاهداً لضمان أن الأشخاص المصرح لهم فقط يمكنهم الوصول إلى المعلومات التي يقدمها المستخدم.
		</p>
		<p>
			لمعرفة المزيد عن إدارة ومعالجة بياناتك من قبل {siteName}، يرجى قراءة {privacyPolicyLink} و {cookiesPolicyLink}.
		</p>
		<h3>17. المدة والتعديل</h3>
		<p>
			ستكون شروط الاستخدام هذه سارية طالما يتم عرضها للمستخدمين، بحيث بمجرد تعديلها أو تحديثها كلياً أو جزئياً، تتوقف هذه الشروط عن السريان، وتصبح شروط الاستخدام الجديدة هي التي تنظم استخدام الموقع الإلكتروني.
		</p>
		<p>
			يحتفظ {siteName} بالحق في مراجعة أو تعديل أو تحديث شروط الاستخدام هذه في أي وقت. في حالة حدوث أي تغيير في شروط الاستخدام هذه لأي سبب من الأسباب، سيقوم {siteName} بإخطار المستخدمين على الصفحة الرئيسية للموقع الإلكتروني بهذا الظرف حتى يكونوا على علم تام ويمكنهم الاطلاع على المراجعات أو التعديلات أو التحديثات لشروط الاستخدام الحالية بما يرضيهم.
		</p>
		<h3>18. أحكام عامة</h3>
		<p>
			لا يمكن بأي حال من الأحوال وتحت أي ظرف من الظروف اعتبار عدم ممارسة {siteName} لحقوقه تنازلاً عنها.
		</p>
		<p>
			العناوين الواردة في هذه الشروط هي مجرد إشارات أو معلومات، بحيث لا تؤثر أو تؤهل أو توسع تفسيرها.
		</p>
		<p>
			في حالة إعلان بطلان أي من البنود الواردة في هذه الشروط، أو اعتبارها تعسفية أو غير قابلة للتنفيذ، كلياً أو جزئياً، من قبل هيئة قضائية أو إدارية، فإن هذا الإعلان سيؤثر بشكل فردي على البند المعني، معتبراً كأنه غير موجود ودون أن يمتد إعلان البطلان أو التعسف أو عدم قابلية التطبيق تحت أي ظرف من الظروف إلى باقي الشروط، التي ستظل قائمة.
		</p>
		<p>
			تخضع شروط الاستخدام هذه، وكذلك {privacyPolicyLink} و {cookiesPolicyLink} للوائح الإسبانية السارية في جميع الأوقات.
		</p>
		<h3>19. خدمة العملاء</h3>
		<p>
			لأي توضيح أو حادث أو شكوى، يمكنك الاتصال بنا من خلال:<br />
			البريد الإلكتروني: {supportLink}<br />
			العنوان البريدي: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'آخر تحديث: 10 يونيو 2024',
		content: `
			<h3>1. الطرف المسؤول والوصف</h3>
			<h5>1.1. المسؤول</h5>
			<p>الشخص المسؤول عن معالجة هذا الموقع هو Remove Background S.L (المشار إليه فيما يلي باسم Remove Background 
			أو الخدمة)، وعنوانه Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, برشلونة، إسبانيا.</p>
			<p>الرقم الضريبي: B56768260<br> البريد الإلكتروني: {supportLink}</p>

			<h5>1.2. الوصف</h5>
			<p>قبول سياسة الخصوصية الخاصة بـ Remove Background (المشار إليها فيما يلي باسم "سياسة الخصوصية") هو شرط ضروري 
				لاستخدام موقعنا الإلكتروني وتقديم الخدمة (المشار إليها فيما يلي باسم "الخدمة").<br>
				تنظم سياسة الخصوصية هذه جمع ومعالجة واستخدام معلوماتك الشخصية وغير الشخصية 
				كمستخدم لـ Remove Background، اعتبارًا من تاريخ السريان الذي يظهر في الرأس.<br>
				لمعالجة بياناتك الشخصية، تمتثل Remove Background للتشريعات المحلية والأوروبية الحالية، 
				وكذلك لوائحها التنفيذية.</p>


			<h3>2. المعلومات المجمعة</h3>
			<p>يمكن الوصول إلى موقعنا الإلكتروني دون الحاجة إلى تقديم أي معلومات، ولكن للتسجيل و/أو 
				التعاقد على خططنا ستحتاج إلى تزويدنا ببعض المعلومات الشخصية. قد تختلف المعلومات (الشخصية 
				أو غير الشخصية) التي تجمعها الخدمة بناءً على ذلك.<br>
				ستصل إلينا المعلومات الشخصية وغير الشخصية التي تجمعها الخدمة بثلاث طرق: 1) ما يتم جمعه تلقائياً 
				2) ما تقدمه لنا طواعية 3) ما يقدمه أطراف ثالثة.</p>

			<h5>2.1. ما يتم جمعه تلقائياً</h5>
			<p>ستتكون هذه المعلومات من:</p>
			<ul>
				<li>المعلومات التي يتم جمعها من خلال ملفات تعريف الارتباط أو الآليات المماثلة المخزنة على جهازك، 
					دائمًا بموافقتك أو وفقًا لأسس قانونية أخرى. راجع سياسة ملفات تعريف الارتباط الخاصة بنا لمزيد من المعلومات.</li>
				<li>عنوان IP الذي يتم منه الاتصال، ونوع الجهاز المستخدم ومواصفاته، وإصدار نظام التشغيل، 
					ونوع المتصفح، واللغة، والتاريخ، والبلد، ووقت الطلب، وعنوان URL الذي أتيت منه، 
					وعنوان URL الذي تذهب إليه، أو شبكة الهاتف المحمول المستخدمة، من بين أمور أخرى.</li>
				<li>بيانات استخدام الخدمة والأخطاء المحتملة المكتشفة أثناء استخدامها.</li>
				<li>بالإضافة إلى ذلك، تستخدم Remove Background خدمة Google Analytics، وهي خدمة تحليلية تقدمها Google، LLC 
					ومقرها في الولايات المتحدة في 1600 Amphitheater Parkway, Mountain View, California 94043. 
					لتقديم هذه الخدمات، يستخدمون ملفات تعريف الارتباط التي تجمع المعلومات، بما في ذلك عنوان IP للمستخدم، 
					والتي سيتم نقلها ومعالجتها وتخزينها بواسطة Google وفقًا للشروط المنصوص عليها على موقع www.google.com. 
					بما في ذلك إمكانية نقل هذه المعلومات إلى أطراف ثالثة لأسباب قانونية أو 
					عندما تقوم هذه الأطراف الثالثة بمعالجة المعلومات نيابة عن Google.</li>
			</ul>
			<p>في جميع الحالات، يمكنك تعطيل ملفات تعريف الارتباط الخاصة بـ Google Analytics من <a href="{externalLink: disableGoogleAnalyticsLink}">هنا</a>.</p>

			<h5>2.2. ما تقدمه طواعية</h5>
			<p>ستتكون هذه المعلومات من:</p>
			<ul>
				<li>جميع البيانات إلزامية.</li>
				<li>المعلومات المطلوبة من قبل Remove Background لإكمال تسجيلك على الموقع: الاسم واللقب والعنوان والبريد الإلكتروني، وغيرها.</li>
				<li>جميع البيانات إلزامية.</li>
				<li>المعلومات، الشخصية أو غير الشخصية، لإكمال التعاقد على الخدمة مثل عنوان بريدك الإلكتروني ورقم بطاقتك الائتمانية أو بطاقة الخصم.</li>
				<li>المعلومات، الشخصية أو غير الشخصية، التي قد تحتوي عليها الرسائل المرسلة عبر قنوات الاتصال أو الرأي المنشأة في الخدمة، 
					على سبيل المثال اسمك وبريدك الإلكتروني.</li>
			</ul>

			<h5>2.3. ما يقدمه أطراف ثالثة</h5>
			<p>ستتكون هذه المعلومات من:</p>
			<ul>
				<li>المعلومات المقدمة من أنظمة الدفع أو معالجي بطاقات الائتمان، مثل وقت الشراء أو مبلغه.</li>
			</ul>


			<h3>3. الحقوق والأغراض</h3>
			<p>نود إعلامك بأن ملء النماذج طوعي. ومع ذلك، إذا لم تملأ الحقول المطلوبة 
				(المميزة عادةً بعلامة النجمة)، فلن يكون استخدام بعض وظائف الخدمة ممكناً أو سيكون محدوداً.<br>
				سيتم دمج البيانات الشخصية التي تقدمها لنا ومعالجتها في سجل أنشطة المعالجة الخاص بـ Remove Background 
				من أجل تلبية طلباتك وتقديم الخدمة المطلوبة وإبقائك على اطلاع بالأمور المتعلقة بنشاط الشركة وخدماتها.<br>
				يمكنك ممارسة حقوق الوصول والتصحيح والحذف وتقييد المعالجة والمعارضة ونقل بياناتك الشخصية 
				في أي وقت عن طريق البريد الإلكتروني الموجه إلى: {supportLink} أو العنوان البريدي: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, برشلونة، إسبانيا.<br>
				في كلتا الحالتين، يجب عليك التعريف بنفسك باسمك ولقبك، وكذلك نسخة من بطاقة هويتك الوطنية، إذا لزم الأمر.<br>
				في حالة منحك الموافقة لغرض محدد، يحق لك سحب الموافقة في أي وقت، 
				دون التأثير على قانونية المعالجة المستندة إلى الموافقة قبل سحبها.<br>
				بالإضافة إلى ذلك، إذا كنت تعتقد أن هناك مشكلة في طريقة تعامل Remove Background مع بياناتك، 
				يمكنك توجيه شكاواك إلى <a href="{knowYourRightsLink}">سلطة حماية البيانات</a> المختصة، حيث تكون <a href="{aepdLink}">الوكالة الإسبانية لحماية البيانات</a> 
				هي المشار إليها في حالة إسبانيا.</p>


			<h3>4. العمر</h3>
			<p>فيما يتعلق باستخدام الخدمة عبر الإنترنت، تقر بأنك بالغ وأن لديك الأهلية القانونية اللازمة 
				للالتزام بهذا الاتفاق واستخدام الموقع وفقاً لشروطه وأحكامه، التي تفهمها وتقر بها بشكل كامل.<br>
				تقر بأن جميع المعلومات التي تقدمها للوصول إلى الخدمة، قبل وأثناء استخدامها، 
				صحيحة وكاملة ودقيقة.</p>


			<h3>5. استخدام البيانات</h3>
			<p>ستستخدم Remove Background البيانات المجمعة من أجل:</p>
			<ul>
				<li>إدارة وتحديث الخدمة (الأساس القانوني هو مصلحتنا المشروعة في الحفاظ على الخدمة وإبقائها محدثة وفي حالة جيدة).</li>
				<li>معالجة الأسئلة التي تطرحها (الأساس القانوني هو مصلحتنا المشروعة في الرد على طلبات وشكوك مستخدمينا).</li>
				<li>معالجة المدفوعات التي تقوم بها (العقد هو الأساس القانوني).</li>
				<li>تقديم الخدمة المتعاقد عليها (العقد هو الأساس القانوني).</li>
				<li>الحفاظ على أمن الخدمة، والتحقيق في الأنشطة غير القانونية، وتنفيذ شروطنا وأحكامنا 
					ومساعدة قوات الأمن في إطار تحقيقاتها المحتملة (الأساس القانوني هو مصلحتنا المشروعة 
					في ضمان والحفاظ على أمن الخدمة ومستخدميها).</li>
			</ul>
			<p>لا تستخدم Remove Background القرارات الآلية، على الرغم من أنها قد تنشئ ملفات تعريف أساسية للمستخدمين، 
				حيث يكون الأساس القانوني هو مصلحتنا المشروعة للأغراض التجارية وتقديم العروض المخصصة.<br>
				كما يمكن لـ Remove Background استخدام معلومات المستخدم في شكل بيانات مجمعة ومجهولة المصدر لعرضها على أطراف ثالثة. 
				قد تشارك أيضاً الإحصائيات والمعلومات الديموغرافية حول المستخدمين واستخدامهم للخدمة مع أطراف ثالثة. 
				ولكن لن يسمح أي من ذلك للأطراف الثالثة بالتعرف عليك شخصياً.</p>

			<h5>5.1. في رسائل البريد الإلكتروني ونماذج الاتصال</h5>
			<p>يحتوي الموقع على تشفير SSL يسمح للمستخدم بإرسال بياناته الشخصية بأمان من خلال نماذج الاتصال القياسية.<br>
				ستخضع البيانات الشخصية المجمعة للمعالجة الآلية وسيتم دمجها في الملفات المناسبة 
				لسجل أنشطة المعالجة والتي تكون Remove Background مالكة لها.</p>
			<p>في هذا الصدد:</p>
			<ul>
				<li>سنتلقى عنوان IP الخاص بك، والذي سيتم استخدامه للتحقق من مصدر الرسالة من أجل تقديم 
					توصيات مناسبة لك (على سبيل المثال، عرض المعلومات باللغة الصحيحة) واكتشاف أي مخالفات محتملة 
					(على سبيل المثال، محاولات الهجوم الإلكتروني المحتملة على الخدمة)، وكذلك البيانات المتعلقة بمزود خدمة الإنترنت الخاص بك.</li>
				<li>كما يمكنك تزويدنا ببياناتك عبر الهاتف والبريد الإلكتروني ووسائل الاتصال الأخرى المشار إليها.</li>
			</ul>
			<p>فيما يتعلق بوسائل الدفع المستخدمة:</p>
			<ul>
				<li>مقدمو خدمات الدفع لدينا للدفع مقابل تقديم خدماتنا هم بطاقة الائتمان أو الخصم. 
					لن تتمكن الخدمة أو موظفوها في أي وقت من الوصول إلى التفاصيل المصرفية (على سبيل المثال، رقم بطاقة الائتمان) 
					التي سيقدمها المستخدم كعميل لتلك الأطراف الثالثة.</li>
			</ul>


			<h3>6. الاحتفاظ بالبيانات</h3>
			<p>فيما يلي المدة التي يتم فيها الاحتفاظ بالبيانات التي تتم معالجتها من قبل الخدمة:</p>
			<ul>
				<li>سيتم الاحتفاظ بالبيانات المفصلة دون فترة حذف.</li>
				<li>
					سيتم الاحتفاظ ببيانات العملاء للحد الأدنى الضروري، ويمكن الاحتفاظ بها حتى:
					<ul>
						<li>5 سنوات، وفقاً للمادة 1964 من القانون المدني (الدعاوى الشخصية بدون مدة خاصة).</li>
						<li>6 سنوات، وفقاً للمادة 30 من القانون التجاري (الدفاتر المحاسبية أو الفواتير، على سبيل المثال).</li>
					</ul>
				</li>
				<li>سيتم الاحتفاظ ببيانات المستخدم لمدة أقصاها 12 شهراً للتمكن من تلبية طلباته.</li>
			</ul>


			<h3>7. البيانات المشتركة مع أطراف ثالثة</h3>
			<p>هناك أطراف ثالثة تدير جزءاً من الخدمة.<br>
				تطلب Remove Background منهم الامتثال لسياسة الخصوصية هذه حسب الاقتضاء، بالإضافة إلى امتلاكهم لسياستهم الخاصة. ومع ذلك، لن تكون Remove Background مسؤولة عن الامتثال لتلك السياسة.<br>
				في بعض الظروف، قد تشارك Remove Background أو تستخدم أو تحتفظ مع أطراف ثالثة بأي من المعلومات الشخصية المجمعة:</p>
			<ul>
				<li>لتقديم الخدمة:</li>
			</ul>
			<p>مقدمو الخدمات الذين يؤدون وظائف نيابة عنا، مثل خدمات الدفع، واستضافة الويب، وتحليلات الأعمال، وخدمة العملاء، أو التسويق عبر الويب. قد يجمع مقدمو الخدمات هؤلاء المعلومات ويصلون إليها بالقدر اللازم لأداء وظائفهم، ولكن لا يُسمح لهم بمشاركة المعلومات أو استخدامها لأي غرض آخر.</p>
			<ul>
				<li>للتعاون مع السلطات المختصة:</li>
			</ul>
			<p>إذا اعتقدنا أنه من الضروري بشكل معقول تلبية أي قانون أو إجراء قانوني أو مصلحة مشروعة. في أي حال، سنقدم فقط المعلومات المطلوبة بشكل صارم.</p>


			<h3>8. التدابير الأمنية</h3>
			<p>تتخذ Remove Background جميع التدابير التقنية والتنظيمية اللازمة لحماية 
				أمن وسلامة المعلومات الشخصية وغير الشخصية المجمعة. 
				سواء ضد الوصول غير المصرح به أو تغييرها العرضي أو فقدانها أو تدميرها.<br>
				في أي حال، لا يمكن لـ Remove Background ضمان الأمن المطلق للمعلومات المجمعة، 
				لذا يجب عليك التعاون واستخدام الحس السليم بشأن المعلومات المشتركة في جميع الأوقات.<br>
				أنت تفهم وتقر بأنه حتى بعد الحذف، قد تظل المعلومات الشخصية وغير الشخصية 
				مرئية في ذاكرة التخزين المؤقت أو إذا قام مستخدمون آخرون بنسخها أو تخزينها.</p>


			<h3>9. التغييرات في سياسة الخصوصية</h3>
			<p>قد نقوم بتحديث سياسة الخصوصية هذه في المستقبل. سنبلغك بالتغييرات عن طريق إرسال إشعار إلى عنوان البريد الإلكتروني المقدم و/أو وضع إشعار في مكان بارز على موقعنا الإلكتروني.</p>


			<h3>10. الاتصال</h3>
			<p>إذا كانت لديك أسئلة حول سياسة الخصوصية هذه، اتصل بنا على:</p>
			<p>البريد الإلكتروني: {supportLink}<br>
				العنوان: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, برشلونة، إسبانيا.</p>
		`
	},
	gdpr: {
		lastUpdate: 'آخر تحديث: 10 يونيو 2024',
		content: `
			<h3>1. من هو المسؤول وكيف يمكن الاتصال به؟</h3>
			<p>المتحكم في هذا الموقع هو Remove Background S.L وعنوانه Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, برشلونة، إسبانيا.</p>
			<p>يمكنك التواصل معه عبر البريد الإلكتروني {supportLink}.</p>

			<h3>2. ما هي البيانات التي يتم جمعها؟</h3>
			<p>
				نقوم تلقائياً بجمع البيانات من خلال ملفات تعريف الارتباط التي نحملها على جهازك، بما في ذلك التحليلات.
				كما نقوم بجمع عنوان IP الذي يتم منه الاتصال، ونوع الجهاز المستخدم وخصائصه،
				وإصدار نظام التشغيل، ونوع المتصفح، واللغة، والتاريخ، والبلد، ووقت الطلب،
				وعنوان URL الذي أتيت منه، وعنوان URL الذي تذهب إليه، وشبكة الهاتف المحمول المستخدمة، وغيرها.
				يقدم المستخدم طواعية بعض المعلومات مثل اسمه ولقبه والبريد الإلكتروني أو المعلومات المصرفية
				للتمكن من الاتصال بنا أو التسجيل في الخدمة أو شراء اشتراك.
			</p>

			<h3>3. فيم تُستخدم البيانات المجمعة؟</h3>
			<p>
				ستستخدم الخدمة البيانات المجمعة، من بين أمور أخرى، لإدارة وتحديث الخدمة، والرد على طلباتك،
				وإرسال نشرتنا الإخبارية والعروض الترويجية عبر البريد الإلكتروني، وإدارة تسجيلك على المنصة، وإدارة وتقديم
				الخدمات المتعلقة باشتراكك، ومعالجة المدفوعات التي تقوم بها وإصدار الفواتير المقابلة،
				والحفاظ على أمن الخدمة، والتحقيق في الأنشطة غير المشروعة، وتنفيذ شروطنا وأحكامنا
				ومساعدة قوات وأجهزة أمن الدولة في إطار تحقيقاتهم المحتملة.
			</p>

			<h3>4. كم مدة الاحتفاظ بها؟</h3>
			<ul>
				<li>سيتم الاحتفاظ بالبيانات المفصلة دون فترة حذف.</li>
				<li>
					سيتم الاحتفاظ ببيانات العملاء للحد الأدنى الضروري، ويمكن الاحتفاظ بها حتى:
					<ul>
						<li>5 سنوات، وفقاً للمادة 1964 من القانون المدني (الدعاوى الشخصية دون مدة خاصة).</li>
						<li>6 سنوات، وفقاً للمادة 30 من القانون التجاري (الدفاتر المحاسبية أو الفواتير، على سبيل المثال).</li>
					</ul>
				</li>
				<li>سيتم الاحتفاظ ببيانات المستخدم لمدة أقصاها 12 شهراً للرد على طلباته.</li>
				<li>سيتم الاحتفاظ ببيانات المستخدم التي تحملها الخدمة على الصفحات والملفات الشخصية على الشبكات الاجتماعية من لحظة تقديم المستخدم موافقته حتى سحبها.</li>
			</ul>

			<h3>5. ما هي حقوقك كمستخدم؟</h3>

			<p>
				حق الوصول: يحق للشخص المتأثر الحصول على تأكيد من مراقب البيانات حول ما إذا كانت
				البيانات الشخصية المتعلقة به تتم معالجتها أم لا.
			</p>
			<p>
				حق التصحيح: يحق للشخص المتأثر الحصول، دون تأخير غير مبرر، من مراقب البيانات
				على تصحيح البيانات الشخصية غير الدقيقة التي تؤثر عليه مباشرة. كما يحق للشخص المعني
				إكمال البيانات الشخصية غير المكتملة، بما في ذلك عن طريق تقديم بيان إضافي.
			</p>
			<p>
				حق الحذف: هو حق الشخص المتأثر في الحصول، دون تأخير غير مبرر، من مراقب البيانات على حذف
				البيانات الشخصية التي تخصه.
			</p>
			<p>
				حق تقييد معالجة البيانات: يتمثل في الحصول على تقييد معالجة بياناتك من قبل المسؤول،
				رغم أن ممارسته لها جانبان: 1) عندما تطعن في دقة بياناتك الشخصية، خلال فترة تسمح
				للمسؤول بالتحقق منها و 2) عندما تكون قد اعترضت على معالجة بياناتك الشخصية التي يقوم بها المسؤول
				بناءً على مصلحة مشروعة أو مهمة ذات مصلحة عامة، بينما يتحقق المسؤول مما إذا كانت هذه الأسباب
				تسود على أسبابك.
			</p>
			<p>
				حق نقل البيانات: It is the right of the affected party to receive the personal data that concerns him, 
				that he has provided to a data controller, in a structured format, of common use and mechanical reading, and 
				to transmit them to another controller without being prevented by the controller to whom they were provided.
			</p>
			<p>
				في هذا الصدد، سيكون للشخص المعني الحق في نقل البيانات الشخصية مباشرة من مراقب
				إلى آخر عندما يكون ذلك ممكناً من الناحية التقنية.
			</p>

			<h3>6. كيف يمكنك ممارسة حقوقك؟</h3>

			<p>
				يمكنك ممارسة حقوق بياناتك الشخصية في أي وقت عن طريق إرسال بريد إلكتروني إلى: {supportLink} أو العنوان البريدي:
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, برشلونة، إسبانيا. في كلتا الحالتين، يجب عليك التعريف بنفسك باسمك ولقبك،
				بالإضافة إلى نسخة من بطاقة هويتك الوطنية، إذا لزم الأمر.<br>
				بالإضافة إلى ذلك، إذا كنت تعتقد أن هناك مشكلة في طريقة تعامل Remove Background مع بياناتك، يمكنك توجيه شكاواك
				إلى <a href="{knowYourRightsLink}">هيئة حماية البيانات</a> المختصة، حيث تكون <a href="{aepdLink}">الوكالة الإسبانية لحماية البيانات</a>
				هي المختصة في حالة إسبانيا.
			</p>

			<h3>7. هل يتم اتخاذ تدابير أمنية؟</h3>
			<p>
				تتخذ الخدمة جميع التدابير التقنية والتنظيمية اللازمة لحماية أمن وسلامة المعلومات الشخصية
				وغير الشخصية التي يتم جمعها. سواء ضد الوصول غير المصرح به والتغيير العرضي أو الفقدان أو التدمير.<br>
				في أي حال، لا يمكن للخدمة ضمان الأمن المطلق للمعلومات المجمعة، لذا يجب عليك التعاون
				واستخدام الحس السليم في جميع الأوقات فيما يتعلق بالمعلومات المشتركة.<br>
				أنت تفهم وتقر بأنه، حتى بعد الحذف، قد تظل المعلومات الشخصية وغير الشخصية مرئية في ذاكرة التخزين المؤقت
				أو إذا تم نسخها أو تخزينها من قبل مستخدمين آخرين.
			</p>

			<h3>8. هل هناك عمليات نقل للبيانات الشخصية أو نقل دولي؟</h3>

			<p>
				نحن لا نقوم بنقل البيانات أو النقل الدولي. ومع ذلك، هناك أطراف ثالثة تدير جزءاً من الخدمة
				نطلب منها الامتثال لسياسة الخصوصية الخاصة بنا بقدر ما تنطبق عليها ولديها سياساتها الخاصة.
				هؤلاء الأطراف الثالثة هم مقدمو خدمات يؤدون وظائف نيابة عنا، مثل استضافة الويب،
				ومراقبة التحليلات، أو تطوير الويب.<br>
				أيضاً، إذا اعتقدنا أنه ضروري بشكل معقول لتلبية أي قانون أو إجراء قانوني أو مصلحة مشروعة.
				في أي حال، سنقدم فقط المعلومات المطلوبة بشكل صارم.
			</p>

		`
	},
	cookiesPolicy: {
		lastUpdate: 'آخر تحديث: 21 يونيو 2024',
		content: `
			<h3>ملخص</h3>
			<ul>
			    <li>ملفات تعريف الارتباط المستخدمة: <strong>خاصة وتابعة لجهات خارجية</strong></li>
			    <li>هل تُستخدم للحصول على إحصائيات؟ <strong>نعم، استناداً إلى مصلحتنا المشروعة في تحسين إدارة الخدمة</strong></li>
			    <li>خدمات الجهات الخارجية التي تقوم بتثبيت ملفات تعريف الارتباط من خلال هذا الموقع: <strong>جوجل، جوجل أناليتكس، كلاودفلير، وسترايب</strong></li>
			</ul>

			<h3>كيفية تكوين وتعطيل ملفات تعريف الارتباط</h3>
			<p>
			    يمكنك السماح أو حظر أو حذف ملفات تعريف الارتباط المثبتة على جهازك من متصفح الويب الخاص بك. إذا لم تسمح بتثبيت ملفات تعريف الارتباط على جهازك،
			    قد تسوء تجربة التصفح. فيما يلي كيفية تكوين ملفات تعريف الارتباط في كل متصفح:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">إيدج</a></li>
			    <li><a href="{externalLink: chromeCookies}">جوجل كروم</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">جوجل أندرويد</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">إنترنت إكسبلورر 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">إنترنت إكسبلورر 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">إنترنت إكسبلورر 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">موزيلا فايرفوكس</a></li>
			    <li><a href="{externalLink: operaCookies}">أوبرا</a></li>
			    <li><a href="{externalLink: safariCookies}">سفاري</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">سفاري موبايل</a></li>
			</ul>

			<h3>1. الأنواع والاستخدامات</h3>
			<p>تستخدم الخدمة ملفات تعريف ارتباط خاصة وتابعة لجهات خارجية لتحسين التصفح وتقديم الخدمة والحصول على إحصائيات حول استخدام الموقع.</p>

			<h3>2. ما هو ملف تعريف الارتباط وما هو استخدامه؟</h3>
			<p>
			    ملف تعريف الارتباط هو ملف نصي يتم إرساله إلى متصفح الويب على جهاز الكمبيوتر أو الهاتف المحمول أو الجهاز اللوحي الخاص بك ويُستخدم لتخزين واسترجاع معلومات
			    حول التصفح الذي تم إجراؤه. على سبيل المثال، لتذكر اسم المستخدم وكلمة المرور الخاصة بك أو تفضيلات ملفك الشخصي.
			</p>

			<h3>3. ما هي أنواع ملفات تعريف الارتباط؟</h3>
			<p>وفقاً لمن يديرها:</p>
			<ul>
			    <li>ملفات تعريف ارتباط خاصة؛ يتم إرسالها إلى متصفحك من معداتنا أو نطاقات الويب الخاصة بنا.</li>
			    <li>ملفات تعريف ارتباط تابعة لجهات خارجية؛ يتم إرسالها إلى متصفحك من معدات أو نطاقات ويب لا نديرها مباشرة، ولكن من قبل جهة خارجية مثل جوجل.</li>
			</ul>
			<p>بناءً على مدة بقائها نشطة، هناك:</p>
			<ul>
			    <li>ملفات تعريف ارتباط الجلسة؛ تبقى في ملف تعريف الارتباط لمتصفحك حتى تغادر الموقع، لذا لا يبقى أي منها على جهازك.</li>
			    <li>ملفات تعريف ارتباط دائمة؛ تبقى على جهازك ويقرأها موقعنا في كل مرة تقوم فيها بزيارة جديدة. تتوقف ملفات تعريف الارتباط هذه عن العمل بعد تاريخ محدد.</li>
			</ul>
			<p>أخيراً، وفقاً لغرضها، لدينا:</p>
			<ul>
			    <li>ملفات تعريف ارتباط تقنية؛ تحسن التصفح والتشغيل السليم للموقع.</li>
			    <li>ملفات تعريف ارتباط التخصيص؛ تسمح بالوصول إلى الخدمة بخصائص محددة مسبقاً بناءً على سلسلة من المعايير.</li>
			    <li>ملفات تعريف ارتباط تحليلية؛ تسمح بقياس وتحليل إحصائي لاستخدام الخدمة المقدمة.</li>
			</ul>
			<p>قائمة ملفات تعريف الارتباط التابعة لجهات خارجية المستخدمة بواسطة <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">جوجل</a>: تسمح ملفات تعريف الارتباط الخاصة بهم (NID أو CONSENT) بتخصيص كيفية ظهور الإعلانات خارج جوجل أو تخزين المعلومات
			        مثل اللغة المفضلة عند عرض نتائج البحث.<br><a href="{externalLink: googleCookieTypes}">مزيد من المعلومات</a> حول أنواع ملفات تعريف الارتباط التي تستخدمها جوجل في خدماتها المختلفة.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">جوجل أناليتكس</a>: تسمح ملفات تعريف الارتباط الخاصة بهم (مثل _ga) بحساب عدد مرات زيارة المستخدم للموقع وكيفية ووقت ومكان الزيارة.<br>
			        في أي حال، يمكنك تعطيل ملفات تعريف ارتباط جوجل أناليتكس من <a href="{externalLink: disableGoogleAnalytics}">هنا</a>.
			    </li>
			    <li>كلاودفلير: لمعرفة المزيد عن سياسة واستخدام ملفات تعريف الارتباط الخاصة بكلاودفلير، انقر <a href="{externalLink: cloudflareCookiesPolicy}">هذا الرابط</a>.</li>
			    <li>سترايب: اعثر على معلومات <a href="{externalLink: stripeCookiesPolicy}">هنا</a> حول سياسة واستخدام ملفات تعريف الارتباط الخاصة بسترايب.</li>
			</ul>
			
		`
	}
};
